// Blood Donation App Schema Definitions

export const BLOOD_GROUPS = [
  'A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'
];

export const DISTRICTS_KERALA = [
  'Alappuzha', 'Ernakulam', 'Idukki', 'Kannur', 'Kasaragod', 
  'Kollam', 'Kottayam', 'Kozhikode', 'Malappuram', 'Palakkad', 
  'Pathanamthitta', 'Thiruvananthapuram', 'Thrissur', 'Wayanad'
];

export const PARISHES_KERALA = [
  // Thiruvananthapuram
  'St. Joseph\'s Cathedral, Palayam',
  'Our Lady of Lourdes Church, Pattom',
  'St. Mary\'s Church, Pattoor',
  'Sacred Heart Church, Thycaud',
  'St. Thomas Church, Nalanchira',
  
  // Ernakulam
  'St. Mary\'s Cathedral Basilica, Ernakulam',
  'Little Flower Church, Edapally',
  'St. Antony\'s Church, Kochi',
  'Sacred Heart Church, Thevara',
  'St. Sebastian Church, Arthunkal',
  
  // Kottayam
  'St. Mary\'s Church, Kuravilangad',
  'St. George Church, Edathua',
  'Valiapally, Kottayam',
  'St. Alphonsa Church, Bharananganam',
  'St. Mary\'s Church, Champakulam',
  
  // Thrissur
  'Our Lady of Lourdes Cathedral, Thrissur',
  'St. Antony\'s Church, Ollur',
  'St. Thomas Church, Palayoor',
  'Sacred Heart Church, Irinjalakuda',
  'St. Mary\'s Church, Arthat',
  
  // Kozhikode
  'St. Joseph\'s Cathedral, Kozhikode',
  'Sacred Heart Church, Koyilandy',
  'St. Mary\'s Church, Thalassery',
  'St. Sebastian Church, Vadakara',
  'Our Lady of Rosary Church, Beypore',
  
  // Kollam
  'St. Sebastian Church, Kollam',
  'Our Lady of Velankanni Church, Kollam',
  'St. Aloysius Church, Elanthoor',
  'Sacred Heart Church, Chavara',
  'St. Mary\'s Church, Karunagappally',
  
  // Alappuzha
  'St. Andrew\'s Basilica, Arthunkal',
  'St. Mary\'s Church, Champakulam',
  'Sacred Heart Church, Alappuzha',
  'St. Sebastian Church, Mannar',
  'Our Lady of Mount Carmel Church, Alappuzha',
  
  // Pathanamthitta
  'St. Mary\'s Orthodox Church, Niranam',
  'Malankara Orthodox Syrian Church, Thiruvalla',
  'St. Thomas Church, Kozhencherry',
  'Sacred Heart Church, Adoor',
  'St. George Church, Puthuppally',
  
  // Idukki
  'St. George Church, Pala',
  'Sacred Heart Church, Thodupuzha',
  'St. Mary\'s Church, Kumily',
  'Our Lady of Lourdes Church, Munnar',
  'St. Sebastian Church, Kattappana',
  
  // Malappuram
  'St. Mary\'s Church, Kondotty',
  'Sacred Heart Church, Perinthalmanna',
  'St. Joseph\'s Church, Tirur',
  'Our Lady of Fatima Church, Manjeri',
  'St. Antony\'s Church, Nilambur',
  
  // Palakkad
  'St. Joseph\'s Church, Palakkad',
  'Sacred Heart Church, Ottappalam',
  'St. Mary\'s Church, Mannarkkad',
  'Our Lady of Lourdes Church, Chittur',
  'St. Thomas Church, Pattambi',
  
  // Wayanad
  'Sacred Heart Church, Kalpetta',
  'St. Mary\'s Church, Mananthavady',
  'St. Joseph\'s Church, Sulthan Bathery',
  'Our Lady of Fatima Church, Meppadi',
  'St. Sebastian Church, Panamaram',
  
  // Kannur
  'St. Joseph\'s Cathedral, Kannur',
  'Sacred Heart Church, Thalassery',
  'St. Mary\'s Church, Iritty',
  'Our Lady of Rosary Church, Payyanur',
  'St. Antony\'s Church, Mattannur',
  
  // Kasaragod
  'St. Lawrence Church, Kasaragod',
  'Sacred Heart Church, Kanhangad',
  'St. Mary\'s Church, Uppala',
  'Our Lady of Mount Carmel Church, Bekal',
  'St. Joseph\'s Church, Nileshwar'
];

export const REQUEST_STATUS = {
  ACTIVE: 'active',
  FULFILLED: 'fulfilled',
  EXPIRED: 'expired',
  CANCELLED: 'cancelled'
};

export const URGENCY_LEVELS = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
  CRITICAL: 'critical'
};

// Donor Schema
export const createDonorSchema = (data) => ({
  id: data.id || null, // Auto-generated by Firestore
  name: data.name,
  email: data.email || null, // Optional
  phoneNumber: data.phoneNumber,
  location: data.location, // Current active location
  district: data.district,
  parish: data.parish || null, // Optional
  age: data.age,
  weight: data.weight,
  bloodGroup: data.bloodGroup,
  lastDonationDate: data.lastDonationDate || null,
  isAvailable: data.isAvailable !== false, // Default true
  totalDonations: data.totalDonations || 0,
  createdAt: data.createdAt || new Date(),
  updatedAt: data.updatedAt || new Date(),
  // Eligibility tracking
  nextEligibleDate: data.nextEligibleDate || null, // Calculated based on last donation
  medicalRestrictions: data.medicalRestrictions || [], // Array of restrictions
  // Privacy settings
  showEmail: data.showEmail || false,
  showFullName: data.showFullName !== false, // Default true
});

// Blood Request Schema
export const createBloodRequestSchema = (data) => ({
  id: data.id || null,
  patientName: data.patientName,
  bloodGroup: data.bloodGroup,
  unitsRequired: data.unitsRequired,
  urgencyLevel: data.urgencyLevel,
  requiredByDate: data.requiredByDate, // Date when blood is required
  hospital: {
    name: data.hospital.name,
    location: data.hospital.location,
    district: data.hospital.district,
    coordinates: data.hospital.coordinates || null
  },
  contactPerson: {
    name: data.contactPerson.name,
    phoneNumber: data.contactPerson.phoneNumber,
    relationship: data.contactPerson.relationship // bystander, family, etc.
  },
  requestedBy: data.requestedBy, // User ID who posted the request
  parish: data.parish || null, // If patient belongs to a parish
  additionalNotes: data.additionalNotes || '',
  status: data.status || REQUEST_STATUS.ACTIVE,
  createdAt: data.createdAt || new Date(),
  updatedAt: data.updatedAt || new Date(),
  expiresAt: data.expiresAt, // Auto-expire after certain time
  // Matching and responses
  interestedDonors: data.interestedDonors || [], // Array of donor IDs
  fulfilledBy: data.fulfilledBy || null, // Donor ID who fulfilled
  fulfilledAt: data.fulfilledAt || null,
});

// Parish Schema
export const createParishSchema = (data) => ({
  id: data.id || null,
  name: data.name,
  location: data.location,
  district: data.district,
  contactPerson: data.contactPerson || null,
  phoneNumber: data.phoneNumber || null,
  email: data.email || null,
  isActive: data.isActive !== false,
  createdAt: data.createdAt || new Date(),
});

// Hospital Schema (for Kerala hospitals integration)
export const createHospitalSchema = (data) => ({
  id: data.id || null,
  name: data.name,
  type: data.type, // government, private, medical_college
  location: data.location,
  district: data.district,
  pincode: data.pincode || null,
  phoneNumber: data.phoneNumber || null,
  hasBloodBank: data.hasBloodBank || false,
  coordinates: data.coordinates || null, // {lat, lng}
  isActive: data.isActive !== false,
});

// Donation History Schema
export const createDonationHistorySchema = (data) => ({
  id: data.id || null,
  donorId: data.donorId,
  requestId: data.requestId || null, // If donated for a specific request
  hospital: data.hospital,
  donationDate: data.donationDate,
  bloodGroup: data.bloodGroup,
  units: data.units || 1,
  notes: data.notes || '',
  createdAt: data.createdAt || new Date(),
});

// Validation functions
export const validateDonor = (donor) => {
  const errors = [];
  
  if (!donor.name || donor.name.trim().length < 2) {
    errors.push('Name must be at least 2 characters long');
  }
  
  if (!donor.phoneNumber || !/^\d{10}$/.test(donor.phoneNumber.replace(/\D/g, ''))) {
    errors.push('Phone number must be 10 digits');
  }
  
  if (donor.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(donor.email)) {
    errors.push('Invalid email format');
  }
  
  if (!donor.age || donor.age < 18 || donor.age > 65) {
    errors.push('Age must be between 18 and 65');
  }
  
  if (!donor.weight || donor.weight < 45) {
    errors.push('Weight must be at least 45 kg');
  }
  
  if (!BLOOD_GROUPS.includes(donor.bloodGroup)) {
    errors.push('Invalid blood group');
  }
  
  return errors;
};

export const validateBloodRequest = (request) => {
  const errors = [];
  
  if (!request.patientName || request.patientName.trim().length < 2) {
    errors.push('Patient name is required');
  }
  
  if (!BLOOD_GROUPS.includes(request.bloodGroup)) {
    errors.push('Invalid blood group');
  }
  
  if (!request.unitsRequired || request.unitsRequired < 1 || request.unitsRequired > 10) {
    errors.push('Units required must be between 1 and 10');
  }
  
  if (!request.requiredByDate) {
    errors.push('Required by date is required');
  } else {
    const requiredDate = new Date(request.requiredByDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    if (requiredDate < today) {
      errors.push('Required by date cannot be in the past');
    }
  }
  
  if (!request.hospital?.name) {
    errors.push('Hospital name is required');
  }
  
  if (!request.contactPerson?.name) {
    errors.push('Contact person name is required');
  }
  
  if (!request.contactPerson?.phoneNumber || !/^\d{10}$/.test(request.contactPerson.phoneNumber.replace(/\D/g, ''))) {
    errors.push('Valid contact phone number is required');
  }
  
  return errors;
};

// Helper functions
export const calculateNextEligibleDate = (lastDonationDate) => {
  if (!lastDonationDate) return null;
  
  const nextDate = new Date(lastDonationDate);
  nextDate.setDate(nextDate.getDate() + 56); // 8 weeks gap
  return nextDate;
};

export const isDonorEligible = (donor) => {
  if (!donor || !donor.isAvailable) return false;
  
  const now = new Date();
  if (donor.nextEligibleDate && new Date(donor.nextEligibleDate) > now) {
    return false;
  }
  
  return true;
};

export const getCompatibleBloodGroups = (requestedBloodGroup) => {
  const compatibility = {
    'A+': ['A+', 'A-', 'O+', 'O-'],
    'A-': ['A-', 'O-'],
    'B+': ['B+', 'B-', 'O+', 'O-'],
    'B-': ['B-', 'O-'],
    'AB+': ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'], // Universal recipient
    'AB-': ['A-', 'B-', 'AB-', 'O-'],
    'O+': ['O+', 'O-'],
    'O-': ['O-'] // Universal donor
  };
  
  return compatibility[requestedBloodGroup] || [];
};
